import { render } from "./IconInstagramV2.vue?vue&type=template&id=b9319ede"
import script from "./IconInstagramV2.vue?vue&type=script&lang=js"
export * from "./IconInstagramV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__